module.exports = __webpack_public_path__ + "img/blueBoxTopRight.7f9e6df6.svg";